import { ResolveFn } from '@angular/router';
import { IEmployee } from '../interfaces/IEmployee';
import { inject } from '@angular/core';
import { EmployeesService } from '../services/EmployeesService';
import { IdentityStore } from '../../../auth/core/stores/IdentityStore';
import { map, of } from 'rxjs';

export const myEmployeeResolver: ResolveFn<IEmployee | true> = () => {
  if (inject(IdentityStore).identity()) {
   return inject(EmployeesService).getMyEmployee().pipe(
     map(res => res.data)
   );
  } else {
    return of(true);
  }
};
